import React from 'react';
import { CommonIconProps } from './Icon';

const DollarIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <rect
      opacity="0.8"
      x="11"
      y="2"
      width="2"
      height="20"
      rx="1"
      fill={color}
    />
    <path
      opacity="0.5"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 9C8 8.12592 8.3418 7.67614 8.7093 7.41153C9.1278 7.11022 9.66002 7 10 7H14C14.34 7 14.8722 7.11022 15.2907 7.41153C15.6582 7.67614 16 8.12592 16 9C16 9.55228 16.4477 10 17 10C17.5523 10 18 9.55228 18 9C18 7.47408 17.3418 6.42386 16.4593 5.78847C15.6278 5.18978 14.66 5 14 5H10C9.33998 5 8.3722 5.18978 7.5407 5.78847C6.6582 6.42386 6 7.47408 6 9C6 9.66002 6.18978 10.6278 6.78847 11.4593C7.42386 12.3418 8.47408 13 10 13H11.8312H12.1691H14C14.8741 13 15.3239 13.3418 15.5885 13.7093C15.8898 14.1278 16 14.66 16 15C16 15.8741 15.6582 16.3239 15.2907 16.5885C14.8722 16.8898 14.34 17 14 17H10C9.66002 17 9.1278 16.8898 8.7093 16.5885C8.3418 16.3239 8 15.8741 8 15C8 14.4477 7.55229 14 7 14C6.44771 14 6 14.4477 6 15C6 16.5259 6.6582 17.5761 7.5407 18.2115C8.3722 18.8102 9.33998 19 10 19H14C14.66 19 15.6278 18.8102 16.4593 18.2115C17.3418 17.5761 18 16.5259 18 15C18 14.34 17.8102 13.3722 17.2115 12.5407C16.5761 11.6582 15.5259 11 14 11H12.1688H11.8309H10C9.12592 11 8.67614 10.6582 8.41153 10.2907C8.11022 9.8722 8 9.33998 8 9Z"
      fill={color}
    />
  </>
);

export default DollarIcon;
